import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebaseConfig";


const MAX_CACHE_USERS = 25;
const CACHE_TTL = 1000 * 60 * 10;
const transactionCache = new Map();

const isExpired = (entry) => {
    return Date.now() - entry.timestamp > CACHE_TTL;
};

const cleanupCache = (protectedUserId = null) => {
    if (transactionCache.size <= MAX_CACHE_USERS) return;
    const removable = [];
    for (const [userId, value] of transactionCache.entries()) {
        // never remove logged-in user
        if (userId === protectedUserId) continue;

        removable.push({
            userId,
            lastAccessed: value.lastAccessed
        });
    }
    removable.sort((a, b) =>
        a.lastAccessed - b.lastAccessed
    );

    while (transactionCache.size > MAX_CACHE_USERS && removable.length) {
        const oldest = removable.shift();
        transactionCache.delete(oldest.userId);
    }
};

export const fetchTransactions = async (
    userId,
    setTransactions = null,
    options = {}
) => {

    const {
        forceRefresh = false,
        protectedUserId = null
    } = options;

    try {
        const cached = transactionCache.get(userId);
        if (
            cached &&
            !forceRefresh &&
            !isExpired(cached)
        ) {
            cached.lastAccessed = Date.now();
            return cached.data;
        }

        if (cached?.promise) {

            const data = await cached.promise;
            return data;
        }

        const fetchPromise = (async () => {

            const partnersRef = collection(
                db,
                "users",
                userId,
                "partners"
            );
            const partnersSnap = await getDocs(partnersRef);
            const allTransactions = [];
            for (const partnerDoc of partnersSnap.docs) {
                const partnerId = partnerDoc.id;
                const partnerData = partnerDoc.data();
                const txRef = collection(
                    db,
                    "users",
                    userId,
                    "partners",
                    partnerId,
                    "transactions"
                );
                const txSnap = await getDocs(txRef);
                txSnap.forEach((doc) => {
                    allTransactions.push({
                        id: doc.id,
                        ...doc.data(),
                        partner:
                            partnerData.name || "Unknown",
                        partnerId,
                        myShare:
                            partnerData.myShare || 100,
                        partnerShare:
                            partnerData.partnerShare || 0
                    });

                });
            }
            transactionCache.set(userId, {
                data: allTransactions,
                timestamp: Date.now(),
                lastAccessed: Date.now(),
                promise: null
            });

            cleanupCache(protectedUserId);

            return allTransactions;

        })();

        transactionCache.set(userId, {
            data: [],
            timestamp: Date.now(),
            lastAccessed: Date.now(),
            promise: fetchPromise
        });

        const data = await fetchPromise;
        return data;

    } catch (error) {

        console.error(
            "Error fetching transactions:",
            error
        );

        return [];
    }
};

export const clearTransactionCache = (userId) => {

    if (!userId) return;

    transactionCache.delete(userId);
};

export const prefetchTransactions = async (
    userId,
    protectedUserId = null
) => {

    const cached = transactionCache.get(userId);

    if (
        cached &&
        !isExpired(cached)
    ) {
        return;
    }

    await fetchTransactions(
        userId,
        null,
        { protectedUserId }
    );
};